module.exports = __webpack_public_path__ + "static/media/it_30th_anniversary_logo@2x.c589a265.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/it_30th_anniversary_logo@2x.png
// module id = 61
// module chunks = 0